import jsCookies from 'js-cookie';
import { USER_IS_RETAILER_COOKIE } from '../../../app/settings';

export async function getUserIsRetailer(): Promise<boolean> {
  return jsCookies.get(USER_IS_RETAILER_COOKIE) === 'true';
}
